import { config } from "./config";
import { setPortalConfig } from "./config/portalConfig";

if (
  location.hostname.includes("eu.app.sinch.com") ||
  location.hostname.includes("app.sinch.com") ||
  location.hostname.includes("sincheu.dub.mmgp.frontend.stg.mmd.zone") ||
  location.hostname.includes("appsinch.dub.mmgp.frontend.stg.mmd.zone") ||
  config.SHELL_ENV.CONFIG_NAME.split(".")[0] === "dashboard"
) {
  setPortalConfig("region", "emea");
} else {
  setPortalConfig("region", "apac");
}
